import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserDataService } from "./services/user/user.service";
import { FormManager } from "./services/forms/form-manager";
import { FormBuilder } from "@angular/forms";
import { ROUTES } from "./utils/routes";
import { SideMenuService } from "./shared/side-menu/side-menu.service";
import { AuthenticationService } from "./services/swagger";
import { lastValueFrom } from "rxjs";
import { Capacitor } from "@capacitor/core";

@Component({
  selector: "auth-code",
  template: "",
})
export class AuthCodeComponent {
  elem: any;

  constructor(
    private formManager: FormManager,
    private fb: FormBuilder,
    private userService: UserDataService,
    private sideMenuService: SideMenuService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit() {
    this.elem = document.documentElement;
  }

  async ionViewWillEnter() {
    let queryParams: any = this.route.snapshot.queryParams;
    if (
      queryParams &&
      queryParams.code &&
      queryParams.session_state &&
      queryParams.state
    ) {
      let submitFn = async () => {
        let result;
        let res = this.authenticationService.apiAuthenticationCallBackPost({
          aDIdentityModel: {
            isApp: Capacitor.getPlatform() === "web" ? false : true,
            ...queryParams,
          },
        });
        result = await lastValueFrom(res);
        await this.userService.login(result);
        if (
          (result && !result.tenantProfiles) ||
          (result &&
            result.tenantProfiles &&
            result.tenantProfiles.length === 0)
        ) {
          const settings = await this.userService.getCurrentUserSettings();
          if (settings && settings.length) {
            const defaultPageSetting = settings.find(
              (s) => s.userSettingName === "DefaultPage",
            );

            if (defaultPageSetting) {
              if (defaultPageSetting.userSettingValue) {
                if (defaultPageSetting.userSettingValue === "quickSearch") {
                  this.router.navigateByUrl(ROUTES.QUICK_SEARCH_PAGE);
                } else {
                  this.router.navigateByUrl(
                    defaultPageSetting.userSettingValue,
                  );
                }
              } else {
                this.router.navigateByUrl(ROUTES.HELP_PAGE);
              }
            } else {
              this.router.navigateByUrl(ROUTES.HELP_PAGE);
            }

            const hideSideMenuSetting = settings.find(
              (s) => s.userSettingName === "HideSideMenu",
            );

            if (hideSideMenuSetting?.userSettingValue === "Yes") {
              this.sideMenuService.toggleSidebar();
            }
          } else {
            this.router.navigateByUrl(ROUTES.HELP_PAGE);
          }
        }
      };
      await this.formManager.submit(this.fb.group({}), submitFn);
    } else {
      await this.userService.logout();
    }
  }
}
